import { render, staticRenderFns } from "./KickOutReportDetail.vue?vue&type=template&id=6d452da4&scoped=true&"
import script from "./KickOutReportDetail.vue?vue&type=script&lang=js&"
export * from "./KickOutReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./KickOutReportDetail.vue?vue&type=style&index=0&id=6d452da4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d452da4",
  null
  
)

export default component.exports